/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".preview-img[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:100%;-o-object-fit:cover;object-fit:cover;height:150px;border:1px solid #dde2ec;border-radius:5px}.help-block[_ngcontent-%COMP%]{margin:0 0 10px!important}"];
export { styles as styles };
